/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface PingResponse {
  name: string;
  status: "SUCCESS" | "ERROR";
  message?: string;
}

export interface ApiHealthPingResponse {
  service: {
    name?: string;
    version?: string;
  };
  deployment: {
    region?: string;
  };
  stage: {
    name?: string;
  };
}

export interface ApiStatusResponse {
  service: {
    name?: string;
    version?: string;
  };
  deployment: {
    region?: string;
  };
  stage: {
    name?: string;
  };
  status: string;
  dependencies: {
    name?: string;
    status?: string;
    message?: string;
  }[];
}

export interface Address {
  /** Address Type ID */
  typeId?: number;
  type: IdObject;
  /**
   * Address Line 1
   * @example "1317 Maple St"
   */
  line1: string;
  /**
   * Address Line 2
   * @example "Room 6"
   */
  line2?: string;
  /**
   * Address Line 3
   * @example null
   */
  line3?: string;
  /**
   * City
   * @example "Springfield"
   */
  city?: string;
  /**
   * Region / State
   * @example "IL"
   */
  region?: string;
  /**
   * ZIP or POSTAL code
   * @example 62706
   */
  zipPostal: string;
  /**
   * Address Line 1
   * @example "1317 Maple St"
   */
  countryCode?: string;
  /**
   * last update date
   * @example "2024-08-01 01:00"
   */
  lastUpdated?: string;
  preferred?: boolean;
  source?: string;
}

export interface IdObject {
  id?: number;
  code?: string;
  description?: string;
}

export interface AddressV1 {
  addressId?: string;
  addressTypeId: number;
  addressType?: AddressType;
  addressLine1: string;
  addressLine2?: string;
  addressLine3Suburb?: string;
  city?: string;
  state?: string;
  zipCode: string;
  zipCodeExt?: string;
  country?: string;
  roomNumber?: string;
  buildingKey?: string;
  buildingName?: string;
  primary?: boolean;
  userCaptured?: boolean;
}

export interface AddressType {
  addressTypeId?: number;
  code?: string;
  description?: string;
}

export interface Authorization {
  authorizationID?: string;
  category?: string;
  doFunction?: string;
  effectiveDate?: string;
  expirationDate?: string;
  functionName?: string;
  grantAuth?: string;
  isActive?: string;
  principal?: string;
  qualifierName?: string;
  qualifierCode?: string;
  qualifierType?: string;
  modifiedBy?: string;
  modifiedDate?: string;
}

export interface Citizenship {
  profileId?: string;
  countryCode: string;
  countryName?: string;
}

export interface ContactsAll {
  contactNumbers?: ContactNumberSource[];
  emails?: Email[];
  addresses?: Address[];
}

export interface ContactNumber {
  contactNumberId?: string;
  contactNumberTypeId: number;
  contactNumberType?: ContactNumberType;
  countryCode?: string;
  areaCode?: string;
  number: string;
  formattedNumber?: string;
  extention?: string;
  primaryPhone?: boolean;
  userCaptured?: boolean;
  regionCode?: string | null;
}

export interface ContactNumberType {
  contactNumberTypeId?: number;
  description?: string;
}

export interface ContactNumberSource {
  typeId: number;
  type?: IdObject;
  /** @example "2024-08-01 00:33" */
  lastUpdated?: string;
  /** @default false */
  preferred?: boolean;
  phoneNumber: string;
  /** @default false */
  canSMS?: boolean;
  source?: string;
}

export interface Contact {
  id?: string;
  name: string;
  phoneNumber: string;
  emailAddress?: string;
  primaryContact: boolean;
}

export interface Contacts {
  contacts?: Contact[];
}

export interface EmergencyContact {
  email?: string;
  phoneNumber?: string;
  secondaryPhoneNumber?: string;
  name?: string;
  address?: string;
  priority?: number;
}

export interface Email {
  typeId?: number;
  type?: IdObject;
  /** @example "terencej@mit.edu" */
  emailAddress?: string;
  /** @example "2024-08-01 01:00" */
  lastUpdated?: string;
  preferred?: boolean;
  source?: string;
}

export interface Language {
  id?: string;
  language: string;
}

export interface Languages {
  languages?: Language[];
}

export interface Passports {
  passports?: Passport[];
}

/** @example {"id":"62e32188-1274-45b3-9bb1-d68c273b6bcd","mitId":987654321,"passportNumber":"A9865B7","issueDate":"2016-07-23T00:00:00.000Z","expiryDate":"2026-07-22T00:00:00.000Z","nationality":"US","profileId":"2e8cbf45-df87-4583-9f56-20da0838a91c","imageUrl":"https://i.picsum.photos/id/1062/200/300.jpg","active":true,"s3Key":"56d21980-2fae-48ad-a607-c88b3957cd3b","contentType":"image/jpeg"} */
export interface Passport {
  id?: string;
  mitId?: string;
  passportNumber: string;
  issueDate: string;
  expiryDate: string;
  nationality: string;
  profileId: string;
  imageUrl?: string;
  active?: boolean;
  s3Key?: string;
  contentType?: string;
}

export interface Profile {
  fullName: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  initials?: string;
  kerberosId: string;
  mitId: string;
  title?: string;
  /** YYYY-MM-DD */
  dateOfBirth?: string;
  preferredContactNumber?: string;
  preferredMitEmailAddress?: string;
  nonMitEmailAddress?: string;
  preferredEmergencyContactName?: string;
  dlcKey?: string;
  dlcName?: string;
  officeLocation?: string;
  affiliation?: string;
  moiraClass?: string;
  moiraStatus?: string;
  hrOrganizationId?: string;
  hasAllocation?: boolean;
  legalFirstName?: string;
  legalLastName?: string;
  legalDisplayName?: string;
}

/** @example {"id":"b9972ce2-17b9-4f1a-b9d9-f2fb3ef5c059","mitId":987654321,"citizenships":[{"profileId":"c7b0410d-60cf-4c2c-b7fd-666a3832aa59","countryCode":"US","countryName":"United States"},{"countryCode":"DE","countryName":"Germany"},{"countryCode":"IE"}],"passport":{"id":"62e32188-1274-45b3-9bb1-d68c273b6bcd","mitId":987654321,"passportNumber":"A9865B7","issueDate":"2016-07-23T00:00:00.000Z","expiryDate":"2026-07-22T00:00:00.000Z","nationality":"US","profileId":"2e8cbf45-df87-4583-9f56-20da0838a91c","imageUrl":"https://i.picsum.photos/id/1062/200/300.jpg","active":true,"s3Key":"56d21980-2fae-48ad-a607-c88b3957cd3b"},"visas":[{"id":"41382742-25cb-4786-aca2-92768dfb3225","mitId":987654321,"issueDate":"2021-02-19T00:00:00.000Z","expiryDate":"2021-09-25T00:00:00.000Z","countryCode":"ZA","profileId":"b9972ce2-17b9-4f1a-b9d9-f2fb3ef5c059","imageUrl":"https://i.picsum.photos/id/1060/200/300.jpg","active":true,"s3Key":"ee6442bf-0a43-4d37-9667-c7b025f29345"}],"languages":["English","German","French"],"active":true} */
export interface TravelProfile {
  id?: string;
  mitId?: string;
  citizenships?: Citizenship[];
  passports?: Passport[];
  visas?: Visa[];
  languages?: string[];
  active?: boolean;
}

export interface Url {
  url?: string;
}

export interface Visas {
  visas?: Visa[];
}

/** @example {"id":"41382742-25cb-4786-aca2-92768dfb3225","mitId":987654321,"issueDate":"2021-02-19T00:00:00.000Z","expiryDate":"2021-09-25T00:00:00.000Z","countryCode":"ZA","profileId":"b9972ce2-17b9-4f1a-b9d9-f2fb3ef5c059","imageUrl":"https://i.picsum.photos/id/1060/200/300.jpg","active":true,"contentType":"image/jpeg","s3Key":"ee6442bf-0a43-4d37-9667-c7b025f29345"} */
export interface Visa {
  id?: string;
  mitId?: string;
  issueDate: string;
  expiryDate: string;
  countryCode: string;
  profileId: string;
  imageUrl?: string;
  active?: boolean;
  s3Key?: string;
  contentType?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://global.api.mit.edu/personal-information/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Personal Information API
 * @version 1.0.1
 * @baseUrl https://global.api.mit.edu/personal-information/v1
 */
export class PersonalInformationApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  apiHealth = {
    /**
     * @description Is the API reachable
     *
     * @name PingList
     * @request GET:/api-health/ping
     * @secure
     */
    pingList: (params: RequestParams = {}) =>
      this.request<ApiHealthPingResponse, any>({
        path: `/api-health/ping`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Can the API connect to all the various integrations that it should be able to
     *
     * @name StatusList
     * @request GET:/api-health/status
     * @secure
     */
    statusList: (params: RequestParams = {}) =>
      this.request<ApiStatusResponse, any>({
        path: `/api-health/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  address = {
    /**
     * No description
     *
     * @name AddressList
     * @summary Gets a list of addresses
     * @request GET:/address
     * @secure
     */
    addressList: (params: RequestParams = {}) =>
      this.request<AddressV1[], any>({
        path: `/address`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AddressCreate
     * @summary Post a new address
     * @request POST:/address
     * @secure
     */
    addressCreate: (data: Address, params: RequestParams = {}) =>
      this.request<Address, any>({
        path: `/address`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AddressDetail
     * @summary Gets the address
     * @request GET:/address/{id}
     * @secure
     */
    addressDetail: (id: string, params: RequestParams = {}) =>
      this.request<Address, any>({
        path: `/address/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AddressUpdate
     * @summary Update the address
     * @request PUT:/address/{id}
     * @secure
     */
    addressUpdate: (id: string, data: Address, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/address/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name AddressDelete
     * @summary Remove the address
     * @request DELETE:/address/{id}
     * @secure
     */
    addressDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/address/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name TypeList
     * @summary Gets a list of address types
     * @request GET:/address/type
     * @secure
     */
    typeList: (params: RequestParams = {}) =>
      this.request<AddressType[], any>({
        path: `/address/type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contactNumber = {
    /**
     * No description
     *
     * @name ContactNumberList
     * @summary Gets a list of contact numbers
     * @request GET:/contact-number
     * @secure
     */
    contactNumberList: (params: RequestParams = {}) =>
      this.request<ContactNumber[], any>({
        path: `/contact-number`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactNumberCreate
     * @summary Post a new contact number
     * @request POST:/contact-number
     * @secure
     */
    contactNumberCreate: (data: ContactNumber, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact-number`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactNumberDetail
     * @summary Gets the contact number
     * @request GET:/contact-number/{id}
     * @secure
     */
    contactNumberDetail: (id: string, params: RequestParams = {}) =>
      this.request<ContactNumber, any>({
        path: `/contact-number/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactNumberUpdate
     * @summary Update the contact number
     * @request PUT:/contact-number/{id}
     * @secure
     */
    contactNumberUpdate: (
      id: string,
      data: ContactNumber,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contact-number/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactNumberDelete
     * @summary Remove the contact number
     * @request DELETE:/contact-number/{id}
     * @secure
     */
    contactNumberDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact-number/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name TypeList
     * @summary Gets a list of contact number types
     * @request GET:/contact-number/type
     * @secure
     */
    typeList: (params: RequestParams = {}) =>
      this.request<ContactNumberType[], any>({
        path: `/contact-number/type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  addresses = {
    /**
     * No description
     *
     * @tags User, New
     * @name TypesList
     * @summary Get a list of available address types
     * @request GET:/addresses/types
     * @secure
     */
    typesList: (
      query?: {
        /**
         * MIT ID to get types for
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IdObject[], any>({
        path: `/addresses/types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name AddressesList
     * @summary Get a person addresses
     * @request GET:/addresses
     * @secure
     */
    addressesList: (
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
        /**
         * Exclude one or more types of addresses.  This is a case insensitive substring of the type description.
         * @example "exclude=hom&exclude=bus will exclude "HOME" and "Business" types"
         */
        exclude?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Address[], any>({
        path: `/addresses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name AddressesCreate
     * @summary Upsert a person"s address
     * @request POST:/addresses
     * @secure
     */
    addressesCreate: (
      data: Address,
      query?: {
        /**
         * MIT ID to get address for
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Address, any>({
        path: `/addresses`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name AddressesDetail
     * @summary Gets the address
     * @request GET:/addresses/{typeId}
     * @secure
     */
    addressesDetail: (
      typeId: string,
      query: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
        /**
         * source system to return
         * @example "SAP"
         */
        source: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Address, any>({
        path: `/addresses/${typeId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name AddressesUpdate
     * @summary Update the address by type, can also use POST addresses for upsert
     * @request PUT:/addresses/{typeId}
     * @secure
     */
    addressesUpdate: (
      typeId: string,
      data: Address,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/addresses/${typeId}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name AddressesDelete
     * @summary Remove the address by type
     * @request DELETE:/addresses/{typeId}
     * @secure
     */
    addressesDelete: (
      typeId: string,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/addresses/${typeId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  contacts = {
    /**
     * No description
     *
     * @tags User, New
     * @name ContactsList
     * @summary Get all contacts for a person
     * @request GET:/contacts
     * @secure
     */
    contactsList: (
      query?: {
        /**
         * MIT ID to get types for
         * @example 987654321
         */
        mitId?: string;
        /**
         * Exclude one or more types of addresses.  This is a case insensitive substring of the type description.
         * @example "exclude=hom&exclude=bus will exclude "HOME" and "Business" types"
         */
        exclude?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactsAll, any>({
        path: `/contacts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contactNumbers = {
    /**
     * No description
     *
     * @tags User, New
     * @name TypesList
     * @summary Get a list of available contact number types
     * @request GET:/contact-numbers/types
     * @secure
     */
    typesList: (
      query?: {
        /**
         * MIT ID to get types for
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IdObject[], any>({
        path: `/contact-numbers/types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name ContactNumbersList
     * @summary Get a person addresses
     * @request GET:/contact-numbers
     * @secure
     */
    contactNumbersList: (
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactNumberSource[], any>({
        path: `/contact-numbers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name ContactNumbersCreate
     * @summary Upsert a person"s address
     * @request POST:/contact-numbers
     * @secure
     */
    contactNumbersCreate: (
      data: ContactNumberSource,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactNumberSource, any>({
        path: `/contact-numbers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name ContactNumbersDetail
     * @summary Gets the contact number for type
     * @request GET:/contact-numbers/{typeId}
     * @secure
     */
    contactNumbersDetail: (
      typeId: string,
      query: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
        /**
         * source system to return
         * @example "SAP"
         */
        source: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactNumberSource, any>({
        path: `/contact-numbers/${typeId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name ContactNumbersUpdate
     * @summary Update the contact number by type, can also use POST contact-numbers for upsert
     * @request PUT:/contact-numbers/{typeId}
     * @secure
     */
    contactNumbersUpdate: (
      typeId: string,
      data: ContactNumberSource,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contact-numbers/${typeId}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name ContactNumbersDelete
     * @summary Remove the contact number by type
     * @request DELETE:/contact-numbers/{typeId}
     * @secure
     */
    contactNumbersDelete: (
      typeId: string,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contact-numbers/${typeId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  documents = {
    /**
     * No description
     *
     * @tags User
     * @name DocumentsDetail
     * @summary Get a document for a user
     * @request GET:/documents/{id}
     * @secure
     */
    documentsDetail: (id: string, params: RequestParams = {}) =>
      this.request<Url, void>({
        path: `/documents/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  emails = {
    /**
     * No description
     *
     * @tags User, New
     * @name TypesList
     * @summary Get a list of available email types
     * @request GET:/emails/types
     * @secure
     */
    typesList: (
      query?: {
        /**
         * MIT ID to get types for
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IdObject[], any>({
        path: `/emails/types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name EmailsList
     * @summary Get a person emails
     * @request GET:/emails
     * @secure
     */
    emailsList: (
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Email[], any>({
        path: `/emails`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name EmailsCreate
     * @summary Upsert a person"s email
     * @request POST:/emails
     * @secure
     */
    emailsCreate: (
      data: Email,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Email, any>({
        path: `/emails`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name EmailsDetail
     * @summary Gets the email address for this type
     * @request GET:/emails/{typeId}
     * @secure
     */
    emailsDetail: (
      typeId: string,
      query: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
        /**
         * source system to return
         * @example "SAP"
         */
        source: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Email, any>({
        path: `/emails/${typeId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name EmailsUpdate
     * @summary Update the address by type, can also use POST email addresses for upsert
     * @request PUT:/emails/{typeId}
     * @secure
     */
    emailsUpdate: (
      typeId: string,
      data: Email,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/emails/${typeId}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, New
     * @name EmailsDelete
     * @summary Remove the email address by type
     * @request DELETE:/emails/{typeId}
     * @secure
     */
    emailsDelete: (
      typeId: string,
      query?: {
        /**
         * MIT ID that is affected
         * @example 987654321
         */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/emails/${typeId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  emergencyContacts = {
    /**
     * No description
     *
     * @tags User
     * @name EmergencyContactsList
     * @summary Get a list of emergency contacts
     * @request GET:/emergency-contacts
     * @secure
     */
    emergencyContactsList: (
      query?: {
        primaryOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Contact[], void>({
        path: `/emergency-contacts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name EmergencyContactsCreate
     * @summary Add an emergency contact
     * @request POST:/emergency-contacts
     * @secure
     */
    emergencyContactsCreate: (data: Contact, params: RequestParams = {}) =>
      this.request<Contact, void>({
        path: `/emergency-contacts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name EmergencyContactsUpdate
     * @summary Update an emergency contact
     * @request PUT:/emergency-contacts
     * @secure
     */
    emergencyContactsUpdate: (data: Contact, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/emergency-contacts`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name EmergencyContactsDetail
     * @summary Get an emergency contact
     * @request GET:/emergency-contacts/{id}
     * @secure
     */
    emergencyContactsDetail: (id: string, params: RequestParams = {}) =>
      this.request<Contact, void>({
        path: `/emergency-contacts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name EmergencyContactsDelete
     * @summary Remove an emergency contact
     * @request DELETE:/emergency-contacts/{id}
     * @secure
     */
    emergencyContactsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/emergency-contacts/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  emergencyInformation = {
    /**
     * @description Get emergancy contacts, from SAP or Mitsis
     *
     * @tags user
     * @name EmergencyInformationList
     * @request GET:/emergency-information
     * @secure
     */
    emergencyInformationList: (
      query?: {
        /** MitId or Kerb for user */
        user?: string;
        affiliation?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmergencyContact[], void>({
        path: `/emergency-information`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  languages = {
    /**
     * No description
     *
     * @tags User
     * @name LanguagesList
     * @summary Get a list of languages
     * @request GET:/languages
     * @secure
     */
    languagesList: (params: RequestParams = {}) =>
      this.request<Languages, any>({
        path: `/languages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  passports = {
    /**
     * No description
     *
     * @tags User, Admin
     * @name PassportsList
     * @summary Get passports for a user, or if Admin, get passports for specified MIT ID
     * @request GET:/passports
     * @secure
     */
    passportsList: (
      query?: {
        /** Passport country code */
        countryCode?: string;
        /** MIT ID of user */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Passports, void>({
        path: `/passports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PassportsCreate
     * @summary Add a passport for the user
     * @request POST:/passports
     * @secure
     */
    passportsCreate: (data: Passport, params: RequestParams = {}) =>
      this.request<Passport, any>({
        path: `/passports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PassportsUpdate
     * @summary Update the user"s passport
     * @request PUT:/passports
     * @secure
     */
    passportsUpdate: (data: Passport, params: RequestParams = {}) =>
      this.request<Url, any>({
        path: `/passports`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PassportsDetail
     * @summary Get a passport for a user
     * @request GET:/passports/{id}
     * @secure
     */
    passportsDetail: (
      id: string,
      query?: {
        /** MIT ID to get a passport for a person who is not the authenticated user (admin) */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Passport, void>({
        path: `/passports/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PassportsDelete
     * @summary Remove a passport for the user
     * @request DELETE:/passports/{id}
     * @secure
     */
    passportsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/passports/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  profile = {
    /**
     * No description
     *
     * @name ProfileList
     * @summary Gets the person"s profile
     * @request GET:/profile
     * @secure
     */
    profileList: (params: RequestParams = {}) =>
      this.request<Profile, any>({
        path: `/profile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ProfileUpdate
     * @summary Update the date of birth
     * @request PUT:/profile
     * @secure
     */
    profileUpdate: (data: Profile, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/profile`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ProfileDetail
     * @summary Gets the person"s profile for mit id
     * @request GET:/profile/{id}
     * @secure
     */
    profileDetail: (id: string, params: RequestParams = {}) =>
      this.request<Profile, any>({
        path: `/profile/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  travelProfiles = {
    /**
     * No description
     *
     * @tags User
     * @name TravelProfilesList
     * @summary Get travel profiles
     * @request GET:/travel-profiles
     * @secure
     */
    travelProfilesList: (params: RequestParams = {}) =>
      this.request<TravelProfile, any>({
        path: `/travel-profiles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TravelProfilesCreate
     * @summary Add a travel profile
     * @request POST:/travel-profiles
     * @secure
     */
    travelProfilesCreate: (data: TravelProfile, params: RequestParams = {}) =>
      this.request<TravelProfile, any>({
        path: `/travel-profiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TravelProfilesUpdate
     * @summary Update a travel profile
     * @request PUT:/travel-profiles
     * @secure
     */
    travelProfilesUpdate: (data: TravelProfile, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/travel-profiles`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TravelProfilesDelete
     * @summary Cancel a travel profile
     * @request DELETE:/travel-profiles/{id}
     * @secure
     */
    travelProfilesDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/travel-profiles/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  visas = {
    /**
     * No description
     *
     * @tags User, Admin
     * @name VisasList
     * @summary Get list of Visas, or if Admin, get Visas for specified MIT ID
     * @request GET:/visas
     * @secure
     */
    visasList: (
      query?: {
        /** MIT ID of user */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Visas, void>({
        path: `/visas`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name VisasCreate
     * @summary Add a Visa
     * @request POST:/visas
     * @secure
     */
    visasCreate: (data: Visa, params: RequestParams = {}) =>
      this.request<Visa, any>({
        path: `/visas`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name VisasUpdate
     * @summary Update a Visa
     * @request PUT:/visas
     * @secure
     */
    visasUpdate: (data: Visa, params: RequestParams = {}) =>
      this.request<Url, any>({
        path: `/visas`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name VisasDetail
     * @summary Get a Visa
     * @request GET:/visas/{id}
     * @secure
     */
    visasDetail: (
      id: string,
      query?: {
        /** MIT ID of user to get a visa for a person who is not the authenticated user (admin) */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Visa, any>({
        path: `/visas/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name VisasDelete
     * @summary Cancel a Visa
     * @request DELETE:/visas/{id}
     * @secure
     */
    visasDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/visas/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}